"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldState = exports.useValue = exports.useDOMField = exports.useField = exports.useRegister = void 0;
const hooks_1 = require("common/hooks");
const react_hook_form_1 = require("react-hook-form");
const validate_1 = require("../validate");
const useErrorFormatter = () => {
    const { formatMessage } = (0, hooks_1.useFormatter)();
    return (promise) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield promise;
        if (typeof result === "string") {
            return result;
        }
        else if (result && result.id) {
            return formatMessage(result.id, result.values);
        }
        else if (result == null || typeof result === "boolean") {
            return undefined;
        }
        else {
            console.log("unknown error", result);
            return "";
        }
    });
};
const useRegister = (props, validators) => {
    const formatError = useErrorFormatter();
    const { fieldPath, control } = props;
    return control.register(fieldPath, {
        validate: (value) => formatError((0, validate_1.validate)(value, validators, props)),
    });
};
exports.useRegister = useRegister;
const useField = (props, validators) => {
    const formatError = useErrorFormatter();
    const { fieldPath, control } = props;
    const { field, fieldState, formState } = (0, react_hook_form_1.useController)({
        control,
        name: fieldPath,
        rules: {
            validate: (value) => formatError((0, validate_1.validate)(value, validators, props)),
        },
    });
    const { value, ref, onChange, onBlur, name } = field;
    return {
        value,
        ref,
        registerProps: { onChange, onBlur, name },
        fieldState,
        formState,
    };
};
exports.useField = useField;
const useDOMField = (props, validators) => {
    const formatError = useErrorFormatter();
    const { fieldPath, control } = props;
    const { fieldState, field } = (0, react_hook_form_1.useController)({
        control,
        name: fieldPath,
    });
    const registerProps = control.register(fieldPath, {
        validate: (value) => formatError((0, validate_1.validate)(value, validators, props)),
    });
    const { value } = field;
    return { value, registerProps, fieldState };
};
exports.useDOMField = useDOMField;
const useValue = (props) => {
    const { control, fieldPath } = props;
    if (fieldPath) {
        return (0, react_hook_form_1.useWatch)({
            control,
            name: fieldPath,
        });
    }
    else {
        return (0, react_hook_form_1.useWatch)({
            control,
        });
    }
};
exports.useValue = useValue;
const useFieldState = (props) => {
    const { fieldPath, control } = props;
    const { fieldState } = (0, react_hook_form_1.useController)({
        control,
        name: fieldPath,
    });
    return {
        fieldState,
    };
};
exports.useFieldState = useFieldState;
